// import $ from 'jquery';
import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

// MOVE TO LIBS-HEAD.js
// import 'jquery-clickout';

//---------- TOUCH EVENTS --------------------------------------//
import '@benmajor/jquery-touch-events';

export default class{ // export class Layout
    
    constructor(options) {

    	// OPTIONS
        this.defaults = {
        	main: undefined,
        	skip_intro: false
        }

        this.options = {};
		Object.assign(this.options, this.defaults, options);
        this.namespace 	= 'layout';

		this.main 		= this.options.main;

        // VARS
		this.$window 	= $(window);
		this.$doc 		= $(document);
		this.$html 		= $('html');
		this.$body 		= $('body');
		this.dbclick    = false;


		this.init()

    }

 	init() {
 		
		this.initMainMenu();

		// this.initSearch();

		// this.paintMenu( document.location.href );

		this.initMobile();

		this.debounceResize(true);

		this.addEvents( true, true );

		setTimeout( ()=>{
			this.onResize();
			this.checkHash();
		}, 17 );

    }


    // -----------------------------------------------------------------[ RESIZE HANDLER ]--------------------------------------------------------------//
    debounceResize(b){
      if ( b ){
        // debounce resize
        this._debResize = _debounce( () => this.onResize(true), 17 );
        this.$window.on( 'resize', this._debResize );
		// Listen for orientation changes
		window.addEventListener("orientationchange", ()=> this.onOrientationChange(), false);
      }
      else{
        if ( this._debResize ){
          this._debResize.cancel();
          this.$window.off( 'resize', this._debResize );
        }        
		// Listen for orientation changes
		window.removeEventListener("orientationchange", ()=> this.onOrientationChange(), false);
      }
    }

    onOrientationChange(){
    	//console.log( 'onOrientationChange');
    	setTimeout( ()=>this.onResize(true), 77 );
    }

	onResize(b){

		let w = this.$window.width(), h = this.$window.height(), mobileAvailheight  = window.innerHeight, $s, $m;

		// this class is used for layouts that need to be resized before revealed. For example .home-MAIN-promo (opacity=0 and resized opacity 1)
		this.$body.addClass( 'resized' );

		// special cases

		//  1) home mobile promo to the availabe height (with or without announcment bar)
		if ( this.$body.hasClass( 'home' ) && this.$html.hasClass( 'mobile' ) && ! this.$body.hasClass( 'home-mobile-resized' ) ){
			
			this.$body.addClass( 'home-mobile-resized' );

			$s = $( '.module-announcement-bar' );
			$m = $( '.hero-image-mobile' );
			if ( $s.length > 0 ){
				$m.height(  mobileAvailheight - $s.outerHeight() );
			}
			else{
				$m.height(  mobileAvailheight );
			}
			$m.find(  '.img-wrapper' ).css({
				height: '100%',
				'min-height': '400px',
				'padding-bottom': 0
			});
		}

		// force same height for slider sustainability/equity
		if ( this.$body.hasClass( 'page-template-practice-about' ) ){
			$( '.slideshow-module-about' ).each( ( i, el )=>{
				let hs = $(el).height();
				if ( w >= 768 && w < 1024 ){
					$(el).find( '.img-col .img-wrapper' ).height( hs );
				}
				else{
					$(el).find( '.img-col .img-wrapper' ).css( 'height', 'auto' );
				}
			});
		}
	}

	
	initMainMenu(){
		let $menu	= $('#menu-main-menu'), $a, $li, $header = $('#desktop-header');


		// add search & work as items to open the menu
		$menu.find( 'li:eq(0)' ).addClass( 'menu-item-has-children' );
		$menu.find( 'li#menu-search' ).addClass( 'menu-item-has-children' );

		$menu.find( 'a' ).each( (i,el)=>{
			$a = $(el);
			$li = $a.parent();
			$li.attr(  'data-index', i );

			/*
			$a.contents().filter(function(){
			    return this.nodeType == 3 && $.trim(this.nodeValue).length;
			}).wrap('<div/>');
			*/

			if ( $li.hasClass( 'menu-item-has-children' ) ){
				$a.addClass( 'no-barba' );
			}			
		});

		$menu.find( 'a' ).on( 'dblclick' , (e)=>{
			if ( $li.hasClass( 'menu-item-has-children' ) ){
				e.preventDefault();
				$a = $(e.currentTarget);
				this.dbclick = true;
				this.main.barba_triggerURL( $a.attr('href'), $a  );
			}
		});


		// add events on click
		$menu.find( 'a' ).on( 'click', (e)=>{
			
			$a = $(e.currentTarget);
			$li = $a.parent();

			if ( $li.hasClass( 'menu-item-has-children' ) ){
				e.preventDefault();

				//setTimeout( ()=> {

					if ( this.dbclick ){
						// return;
					}
				
					if ( $li.hasClass( 'selected' ) ){
						this.openDesktopMenu( false );
					}
					else{
						this.clearAllMenuSelections();

						$li.addClass( 'selected' );
						if ( $li.attr( 'data-index' ) ==  0  ){
							$header.find( '.work-submenu' ).addClass( 'selected' );
						}
						if ( $li.attr( 'id' ) === 'menu-search' ){
							$header.find( '.search-submenu' ).addClass( 'selected' );
							$header.find( '#search-form-1' ).val( '' ).focus();
						}

						this.openDesktopMenu( true );
					}

				//}, 0 );
			}
			else{
				this.openDesktopMenu( false );
			}
		});

		$menu.find( 'a' ).on( 'mouseover', (e)=>{

			$a = $(e.currentTarget);
			$li = $a.parent();

			//console.log( 'over' )

		});


		$menu.find( 'a' ).on( 'mouseleave', (e)=>{

			$a = $(e.currentTarget);
			$li = $a.parent();

			
			//console.log( 'out' )
			
		});



		
		$header.on( 'click', (e)=>{

			if ( !this.$body.hasClass( 'menu-open' ) ){
				return;
			}

			$a = $(e.target);


			// if NOT search form open
			if ( $a.hasClass( 'module-search-form' ) || $a.parents( '.module-search-form' ).length > 0 ){
				return;
			}

			// if NOT a or svg
			if ( ! $a.is( 'a' ) && ! $a.is( 'svg' ) ){
				this.openDesktopMenu(  false  );
			}

		} );
		
		
		
		//this.openDesktopMenu( true );

	}

	clearAllMenuSelections(){
		let $menu = $('#menu-main-menu'), $header = $('#desktop-header');
		$menu.find( 'li.menu-item-has-children' ).removeClass( 'selected' );
		$header.find( '.work-submenu' ).removeClass(  'selected' );
		$header.find( '.search-submenu' ).removeClass(  'selected' );
	}

	openDesktopMenu( b ){
		let $menu	= $('#menu-main-menu'), $scroll = $('#desktop-header .menu-overlay'), $header = $('#desktop-header');

		if ( b ){
			if ( !this.$body.hasClass( 'menu-open' ) ){
				this.$body.addClass( 'menu-open' );

				if ( this.$html.hasClass( 'mac' ) ){
					disableBodyScroll( $scroll[0] );
				}
				

				this.activateClickOut( true );
			}
		}
		else{
			if ( this.$body.hasClass( 'menu-open' ) ){
				this.$body.removeClass( 'menu-open' );

				if ( this.$html.hasClass( 'mac' ) ){
					enableBodyScroll( $scroll[0] );
				}

				this.clearAllMenuSelections();
				this.activateClickOut( false );
			}
		}
	}

	activateClickOut(b){
		let $scroll = $('#desktop-header .menu-overlay, #desktop-header .menu-container' );
		if ( b ){
			$scroll.on( 'clickout', ()=>{
				this.openDesktopMenu(  false  );
			} );
		}
		else{
			$scroll.off( 'clickout' );
		}
	}

	/*
	openDrawer( b ){
		let $scroll = $('.drawer .inner');

		if ( b ){
			if ( !this.$body.hasClass( 'drawer-open') ){
				this.$body.addClass( 'drawer-open' );
				disableBodyScroll( $scroll[0] );

				this.menu_timeline.pause();
				this.menu_timeline.seek(0);
				setTimeout( ()=>{
					this.menu_timeline.restart();
				}, 200 );
			}
		}
		else{
			if ( this.$body.hasClass( 'drawer-open') ){
				//setTimeout( ()=>{
					this.$body.removeClass( 'drawer-open' );
				//}, 300);

				enableBodyScroll( $scroll[0] );

				this.menu_timeline.reverse();
			}
		}
	}
	*/

	/*
	initSearch(){
		let $s = $('#desktop-header').find('.search-icon .btn'), $input = $('.module-search-form').find('.search-field');


		$s.on( 'click', ()=>{
			if ( ! this.$body.hasClass( 'activate-search' ) ){
				this.$body.addClass( 'activate-search' );
				$input.val( '' );
				$input.focus();				
			}
			else{
				if ( $input.val() ){
					$input.parents( '.search-form' ).submit();
				}
				else{
					this.$body.removeClass( 'activate-search' );
				}
			}
		});

		$('#desktop-header').find('.search-icon').on( 'clickout', ()=>{
			this.$body.removeClass( 'activate-search' );
		} );


		$input.on( 'blur', (e)=>{
			//console.log( e )
			//this.$body.removeClass( 'activate-search' );
		});

		// ajaxify search trough Barba
		$('.module-search-form .search-form').on( 'submit', (e) =>{
			e.preventDefault();

			let $form 	= 	$(e.currentTarget),
				url 	=	$form.attr( 'action' ) + '?s=' + $form.find( '.search-field' ).val();

			this.main.barba_triggerURL( url, $form );
		});

		
	}
	*/
	

	/*
	paintMenu( url ){
		let menus = [$('#menu-main-menu'), $('#menu-main-menu-1'), $('#menu-footer-menu')], i, $mnu, $li, found,
			current 		= 'current-menu-item',
			unselected  	= 'state-all-unselected';

		for( i=0; i<menus.length; i++ ){
			$mnu = menus[i];
			$li = $mnu.find( 'li' );
			found = false;

			// reset
			$li.removeClass( current ).removeClass( unselected );
			// find which one if selected
			$li.each( function(){
				if ( $(this).find( 'a' ).attr( 'href' ) === url ){
					$(this).addClass( current );
					found = true;
				}
			});
			// if there is no selection -> unselected ( only for main menu's )
			if ( !found && i < 2 ){
				$li.addClass( unselected );
			}
		}

		// special cases ( mostly single templates, taxonomies and categories, sub-pages )
		// portfolio
		if ( this.$body.hasClass( 'single-project' ) || this.$body.hasClass( 'page-template-portfolio' ) || this.$body.hasClass( 'tax-project_category' ) ){
			this.setMenuSelection( 0, current, unselected );
		}
		// profile
		else if ( this.$body.hasClass( 'parent-pageid-9' ) || this.$body.hasClass( 'single-people' ) ){
			this.setMenuSelection( 2, current, unselected );
		}
		// news
		else if ( this.$body.hasClass( 'single' ) || this.$body.hasClass( 'page-template-news' ) || this.$body.hasClass( 'category' ) ){
			this.setMenuSelection( 3, current, unselected );
		}

	}
	*/

	/*
	setMenuSelection( index, current, unselected ){
		let menus = [$('#menu-main-menu'), $('#menu-main-menu-1')], $mnu, $li, i;
		for( i=0; i<menus.length; i++ ){
			$mnu = menus[i];
			$li = $mnu.find( 'li' );
			// reset
			$li.removeClass( unselected );
			// set
			$mnu.find( 'li:eq(' + index + ')' ).addClass( current );
		}		
	}
	*/

	//----------------------------------------------------------- MOBILE ---------------------------------------//
	
	initMobile(){
		$('#burger').on( 'tap', 		()=>this.openDrawerMobile(true) );
		$('#mobile-close').on( 'tap', 	()=>this.openDrawerMobile(false) );

		// this.initMobileSearch();
		// this.openDrawerMobile( true );
	}
	
	openDrawerMobile( b ){
		let $scroll = $('#mobile-header .menu-overlay .inner');
		if ( b ){
			if ( !this.$body.hasClass( 'menu-mobile-open') ){
				this.$body.addClass( 'menu-mobile-open' );
				disableBodyScroll( $scroll[0] );
			}
		}
		else{
			if ( this.$body.hasClass( 'menu-mobile-open') ){
				this.$body.removeClass( 'menu-mobile-open' );
				enableBodyScroll( $scroll[0] );
			}
		}
	}
	

	/*
	initMobileSearch(){
		let $s = $('#drawer-mobile .search'), $input = $('#drawer-mobile .searchfield');
		$s.on( 'click', ()=>{
			$('#drawer-mobile').addClass( 'activate-search' );
			$input.focus();
		});
		$input.on( 'blur', ()=>{
			$('#drawer-mobile').removeClass( 'activate-search' );
		})
	}
	*/

	/*
	resetMobileMenu(){
		let $li, $a;
		$('#menu-mobile-menu > li').each((i,el)=>{
			$li = $(el);
			if ( $li.hasClass( 'menu-item-has-children' ) ){
				$a = $li.find( '> a' );
				if ( $a.data( 'open') ){
					$a.click();
				}
			}
		});
		$('#scroll-panel').scrollTop(0);	
	}
	*/

	
 	checkHash(){
 		let hash = document.location.hash, $a, $el, href, url;

 		//console.log( 'hash = ' + hash );

 		// on page load, if the url has an hash it will try to find an element with the hash ID and scroll to it.
 		if ( hash ){
 			// anchors (https://mspc.local/support/other-ways-to-give/#park-dedications)
 			$a = $( hash );
 			if ( $a.length > 0 ){
 				//console.log( 'hash on load' )
 				this.scrollToHash( $a );
 			}
 			// menus
 			/*
 			hash = hash.substring(1).replace( /-/g , ' ');
 			$a = $('#' + hash );
 			if ( $a.length > 0 ){
 				if ( $a.attr( 'name') === hash ){
 					this.scrollToHash( $a );
 				}
 			} 
 			*/
 		}


 	}

 	addEvents(b, firstTime){

 		if ( b ){

 			//$( 'a' ).each( (i,el)=>{this.onFetchHash(el,true)} );

	 		// check urls with hashes from menus ( Paractice/About for example)
	 		$('a.menu-anchor').on( 'click', (e)=>{this.onClickMenuAnchor(e)} );
	 		$('main a').on( 'click', (e)=>{this.checkHashLinks(e)} );

	 		// only once for the footer
	 		if ( firstTime ){
	 			$('#menu-footer-menu a').on( 'click', (e)=>{this.checkHashLinks(e)} );
	 		}

 		}
 		else{

 			//$( 'a' ).each( (i,el)=>{this.onFetchHash(el,false)} );
	 		$('a.menu-anchor').off( 'click', (e) =>{this.onClickMenuAnchor(e)} );
	 		$('main a').off( 'click', (e)=>{this.checkHashLinks(e)} );

 		}
 	}

 	onClickMenuAnchor(e){
 		let hash, $a, $el, href;
		$a = $(e.currentTarget);
		href = $a.attr( 'href' );
		hash = href.substring(1).replace( /-/g , ' ');
		$el = $( href );
		if ( $el.length > 0 ){
			e.preventDefault();

			// the offset is already defined in the html !!!

			//this.scrollToHash( $el, $a.attr( 'data-offset' )? parseInt($a.attr( 'data-offset' )) : false, 0.01 );
			this.scrollToHash( $el, 0.1, 0.01 );
			// document.location.hash = href.substring(1).replace( /-/g , ' ')
			// history.replaceState(null, null, document.location.pathname + '#' + hash );
		}
 	}

 	checkHashLinks(e){
 		let hash, $a, $el, href, c;
		$a = $(e.currentTarget);
		href = $a.attr( 'href' );

		if ( href.length <= 1 ){
			return true;
		}


		if ( href.indexOf( '#' ) !== -1 ){
			c = href.split( '#' );
			hash = c[1];
		}
		$el = $( '#' + hash );

		// heck if element #hash exist and the link belong to  same page
		if ( $el.length > 0 && document.location.href.indexOf(c[0]) !== -1  ){
			e.preventDefault();

			// the offset is already defined in the html !!!

			//this.scrollToHash( $el, $a.attr( 'data-offset' )? parseInt($a.attr( 'data-offset' )) : false, 0.01 );
			this.scrollToHash( $el, 0.1, 0.01 );
			// document.location.hash = href.substring(1).replace( /-/g , ' ')
			// history.replaceState(null, null, document.location.pathname + '#' + hash );
		}
  	}


 	scrollToHash( $el, offset, delay ){
 		gsap.to( $(window), {duration: 0.8, scrollTo: { y : $el[0], offsetY: offset?offset:0 }, delay: delay?delay:0.4, ease: 'power.easeOut' });
 	}


	onBarbaChangeState( state, data ){
		switch ( state ){
			case 'before':
				this.dbclick  = false;
				this.addEvents( false );
				this.openDesktopMenu( false );
				this.openDrawerMobile( false );
				break;
			case 'beforeEnter':
				// this.paintMenu( data.next.url.href );
				this.onResize();
				break;
			case  'after':
				this.checkHash();
				this.addEvents( true );
				break;
		}
	}

}

